import * as ENVIRONMENT_JS from './environment.js';

export const ENVIRONMENT = ENVIRONMENT_JS;
